import Vue from 'vue';
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from "../const";
import {
  ADD_TEMPLATE, CHAT_SEARCH, CHAT_SEARCH_RESET,
  CHAT_SEND_IMAGE,
  CHAT_SEND_MESSAGE, CLOSE_TICKET, DELETE_TEMPLATE, EDIT_TEMPLATE, HANDLE_BLACKLIST_USER,
  LOAD_CHAT,
  LOAD_CHATS_LIST,
  LOAD_TEMPLATES,
  RESET_CHATS
} from "../const/chats";

export default {
  namespaced: true,
  state: {
    lastLoadedChatId: null,
    chatsList: {
      chats: [],
      pages: 0,
      amount: 0,
      total: 0,
    },
    searchResult: {
      chats: [],
      amount: 0,
    },
    activeChat: {
      id: null,
      order_id: null,
      member: null,
      client_in_blacklist: false,
      blacklist_note: '',
      stats: {},
      messages: [],
      exchanges: [],
      tickets: [],
      fullyLoaded: false,
      minId: null,
      lastMessageId: null,
    },
    templates: [],
  },
  getters: {
    chatsList: state => state.chatsList,
    activeChat: state => state.activeChat,
    activeChatId: state => state.activeChat.id,
    activeChatIsFullyLoaded: state => state.activeChat.fullyLoaded,
    lastMessageId: state => state.activeChat.lastMessageId,
    templates: state => state.templates,
    searchResult: state => state.searchResult,
  },
  actions: {
    [LOAD_CHATS_LIST]: async ({ dispatch, commit }, { params, resetList }) => {
      const request = await dispatch(HTTP_GET, {
        method: LOAD_CHATS_LIST,
        params,
        no_commit: true,
        namespace: 'chats',
      }, { root: true });

      if (request && request.data && request.data.success) {
        commit(LOAD_CHATS_LIST, { chatsList: request.data.data, resetList });
        return { success: true };
      } else if (request && request.data) {
        return request.data;
      } else {
        return { success: false }
      }
    },
    [LOAD_CHAT]: async ({ dispatch, commit, state }, { id, loadMore }) => {
      if (id) {
        commit('updateLastLoadedChatId', id);
        if (id !== state.activeChat.id) {
          commit('resetActiveChat');
        }
        const params = {};
        if (loadMore) {
          params.minId = state.activeChat.minId;
        }
        const request = await dispatch(HTTP_GET, {
          method: LOAD_CHAT,
          replace: { id },
          params,
          no_commit: true,
          namespace: 'chats',
        }, { root: true });
        if (request.success) {
          commit(LOAD_CHAT, { data: request.data, id, loadMore });
          return request;
        } else if (request && request.data) {
          return request.data;
        } else {
          return { success: false }
        }
      }
    },
    [LOAD_TEMPLATES]: async ({ dispatch, commit }) => {
      const request = await dispatch(HTTP_GET, {
        method: LOAD_TEMPLATES,
        no_commit: true,
        namespace: 'chats',
      }, { root: true });
      if (request.success) {
        commit(LOAD_TEMPLATES, { data: request.data });
      }
      return request;
    },
    [ADD_TEMPLATE]: async ({ dispatch, commit }, body) => {
      const request = await dispatch(HTTP_POST, {
        method: ADD_TEMPLATE,
        no_commit: true,
        body,
        namespace: 'chats',
      }, { root: true });
      if (request.success) {
        commit(LOAD_TEMPLATES, { data: request.data.data });
      }
      return request;
    },
    [CLOSE_TICKET]: async ({ dispatch, commit }, id) => {
      const request = await dispatch(HTTP_POST, {
        method: CLOSE_TICKET,
        no_commit: true,
        replace: { id },
        namespace: 'chats',
      }, { root: true });
      return request ? request.data : { success: false, message: 'Bad request' };
    },
    [EDIT_TEMPLATE]: async ({ dispatch, commit }, { id, text }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_TEMPLATE,
        no_commit: true,
        replace: { id },
        body: { text },
        namespace: 'chats',
      }, { root: true });
      return request;
    },
    [DELETE_TEMPLATE]: async ({ dispatch, commit }, id) => {
      const request = await dispatch(HTTP_DELETE, {
        method: DELETE_TEMPLATE,
        no_commit: true,
        params: { id },
        namespace: 'chats',
      }, { root: true });
      return request;
    },
    [CHAT_SEND_MESSAGE]: async ({ dispatch, commit }, { id, message }) => {
      const request = await dispatch(HTTP_POST, {
        method: CHAT_SEND_MESSAGE,
        params: { id },
        body: { message },
        no_commit: true,
        namespace: 'chats',
      }, { root: true });

      if (request.success) {
        commit(CHAT_SEND_MESSAGE, { data: request.data, id });
      }
      return request;
    },
    [CHAT_SEND_IMAGE]: async ({ dispatch, commit }, { id, message }) => {
      const request = await dispatch(HTTP_POST, {
        method: CHAT_SEND_IMAGE,
        params: { id },
        body: { message },
        no_commit: true,
        namespace: 'chats',
      }, { root: true });

      if (request.success) {
        commit(CHAT_SEND_MESSAGE, { data: request.data.data, id });
      }
      return request;
    },
    [CHAT_SEARCH]: async ({ dispatch, commit }, { mode, query }) => {
      if (mode && query) {
        const request = await dispatch(HTTP_GET, {
          method: CHAT_SEARCH,
          replace: { mode },
          params: { query },
          no_commit: true,
          namespace: 'chats',
        }, { root: true });
        if (request.success) {
          commit(CHAT_SEARCH, { data: request.data.data });
        }
        return request;
      }
    },
    [CHAT_SEARCH_RESET]: async ({ commit }) => {
      commit(CHAT_SEARCH_RESET);
    },
    [HANDLE_BLACKLIST_USER]: ({ commit }, note) => {
      commit(HANDLE_BLACKLIST_USER, note);
    },
  },
  mutations: {
    updateLastLoadedChatId: ( state, id ) => {
      Vue.set(state, 'lastLoadedChatId', id);
    },
    resetActiveChat: (state) => {
      Vue.set(state, 'activeChat', {
        id: null,
        member: null,
        messages: [],
        exchanges: [],
        stats: {},
        fullyLoaded: false,
        minId: null,
      });
    },
    [LOAD_CHATS_LIST]: (state, { chatsList, resetList }) => {
      const chats = resetList ? chatsList.chats : [...state.chatsList.chats, ...chatsList.chats];
      Vue.set(state.chatsList, 'chats', chats);
      Vue.set(state.chatsList, 'pages', chatsList.pages || 1);
      Vue.set(state.chatsList, 'amount', chatsList.amount || 0);
      Vue.set(state.chatsList, 'total', chatsList.total || 0);
    },
    [LOAD_CHAT]: (state, { data, id, loadMore }) => {
      if (state.lastLoadedChatId === id) {
        if (!loadMore) {
          Vue.set(state.activeChat, 'id', id);
          Vue.set(state.activeChat, 'order_id', data.order_id);
          Vue.set(state.activeChat, 'member', data.client_name);
          Vue.set(state.activeChat, 'client_in_blacklist', data.client_in_blacklist);
          Vue.set(state.activeChat, 'blacklist_note', data.blacklist_note);
          Vue.set(state.activeChat, 'exchanges', data.exchanges || []);
          Vue.set(state.activeChat, 'tickets', data.tickets || []);
          Vue.set(state.activeChat, 'stats',  data.stats || {});
        }
        if (!state.activeChat.fullyLoaded) {
          Vue.set(state.activeChat, 'fullyLoaded', true); // TODO: fix
        }
        const messages = {
          ...data.messages,
          ...state.activeChat.messages,
        };
        const lastMessage = messages[messages.length - 1];
        if (lastMessage) {
          const lastMessageId = lastMessage.id;
          if (state.activeChat.lastMessageId !== lastMessageId) {
            Vue.set(state.activeChat, 'lastMessageId', lastMessageId);
          }
        }

        Vue.set(state.activeChat, 'messages', messages);
        // if (!state.activeChat.minId || loadMore) {
        //   Vue.set(state.activeChat, 'minId', data.minId);
        // }
        const currentChat = state.chatsList.chats[id];
        if (currentChat) {
          currentChat.unreaded_count = 0;
        }
      }
    },
    [LOAD_TEMPLATES]: (state, { data }) => {
      Vue.set(state, 'templates', data);
    },
    [CHAT_SEND_MESSAGE]: (state, { data, id }) => {
      console.log('Chat message sent... ', data, id);
    },
    [CHAT_SEARCH]: (state, { data }) => {
      Vue.set(state, 'searchResult',  data);
    },
    [CHAT_SEARCH_RESET]: (state) => {
      Vue.set(state, 'searchResult',  {
        chats: [],
        amount: 0,
      });
    },
    [HANDLE_BLACKLIST_USER]: (state, data) => {
      Vue.set(state.activeChat, 'client_in_blacklist', !state.activeChat.client_in_blacklist);
      if (state.activeChat.client_in_blacklist && data && data.note) {
        Vue.set(state.activeChat, 'blacklist_note', data.note);
      }
    },
    [RESET_CHATS]: (state) => {
      Vue.set(state, 'chatsList', {
        chats: [],
        pages: 0,
      });
    },
  },
};
